<template
  ><svg
    width="200"
    height="156"
    viewBox="0 0 200 156"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="43.7274"
      cy="127.697"
      rx="13.4895"
      ry="5.95127"
      transform="rotate(-39.9685 43.7274 127.697)"
      fill="black"
    />
    <ellipse
      cx="61.9779"
      cy="142.774"
      rx="13.4895"
      ry="5.95127"
      transform="rotate(-39.9685 61.9779 142.774)"
      fill="black"
    />
    <ellipse
      cx="50.088"
      cy="137.984"
      rx="17.0645"
      ry="8.17332"
      transform="rotate(-39.9685 50.088 137.984)"
      fill="black"
    />
    <ellipse
      rx="13.4895"
      ry="5.95127"
      transform="matrix(-0.766398 -0.642366 -0.642366 0.766398 158.785 127.697)"
      fill="black"
    />
    <ellipse
      rx="13.4895"
      ry="5.95127"
      transform="matrix(-0.766398 -0.642366 -0.642366 0.766398 140.535 142.774)"
      fill="black"
    />
    <ellipse
      rx="17.0645"
      ry="8.17332"
      transform="matrix(-0.766398 -0.642366 -0.642366 0.766398 152.425 137.984)"
      fill="black"
    />
    <circle cx="100.981" cy="91.4594" r="63.4802" fill="#D9B892" />
    <ellipse
      cx="37.4156"
      cy="82.5463"
      rx="7.14153"
      ry="17.4571"
      transform="rotate(23.0401 37.4156 82.5463)"
      fill="black"
    />
    <ellipse
      cx="53.9885"
      cy="83.9007"
      rx="11.7016"
      ry="17.4571"
      transform="rotate(-35.4804 53.9885 83.9007)"
      fill="black"
    />
    <ellipse
      cx="96.2203"
      cy="80.1498"
      rx="6.3617"
      ry="15.6827"
      transform="rotate(-35.4804 96.2203 80.1498)"
      fill="black"
    />
    <ellipse
      cx="135.102"
      cy="80.1498"
      rx="6.3617"
      ry="15.6827"
      transform="rotate(-35.4804 135.102 80.1498)"
      fill="black"
    />
    <ellipse
      cx="150.639"
      cy="81.2036"
      rx="9.82311"
      ry="15.6827"
      transform="rotate(-13.2517 150.639 81.2036)"
      fill="black"
    />
    <ellipse
      cx="158.732"
      cy="76.2467"
      rx="7.43545"
      ry="15.6827"
      transform="rotate(-39.8832 158.732 76.2467)"
      fill="black"
    />
    <path
      d="M189.658 46.9485C199.517 60.0547 187.316 70.1122 179.982 73.5027C147.118 82.9679 113.646 83.4637 83.738 79.674C64.7176 77.2639 71.7203 71.9065 82.3181 65.9674C82.9053 58.475 84.5243 47.3074 87.9287 31.0603L97.3736 19.7784C104.274 8.26927 116.878 6.52414 122.318 7.09022C154.696 12.1471 158.345 65.0204 158.863 61.6996C159.278 59.0429 163.187 52.1693 165.089 49.0645C169.17 42.8983 179.798 33.8423 189.658 46.9485Z"
      fill="#F08BA9"
    />
    <path
      d="M100.696 47.5122C118.035 56.6937 43.9502 74.6325 83.738 79.674M83.738 79.674C113.646 83.4637 147.118 82.9679 179.982 73.5027C187.316 70.1122 199.517 60.0547 189.658 46.9485C179.798 33.8423 169.17 42.8983 165.089 49.0645C163.187 52.1693 159.278 59.0429 158.863 61.6996C158.345 65.0204 154.696 12.1471 122.318 7.09022C116.878 6.52414 104.274 8.26927 97.3736 19.7784L87.9287 31.0603C79.9133 69.3126 81.7951 79.4079 83.738 79.674Z"
      stroke="#F08BA9"
    />
    <path
      d="M10.718 47.1429C0.85843 60.2491 13.06 70.3066 20.3932 73.6971C53.2573 83.1624 86.7302 83.6581 116.638 79.8685C135.658 77.4584 128.655 72.101 118.058 66.1618C117.47 58.6694 115.851 47.5019 112.447 31.2547L103.002 19.9729C96.1018 8.46373 83.4975 6.7186 78.0579 7.28467C45.6796 12.3416 42.031 65.2149 41.5123 61.8941C41.0974 59.2374 37.189 52.3637 35.2867 49.259C31.2052 43.0927 20.5775 34.0368 10.718 47.1429Z"
      fill="#F08BA9"
    />
    <path
      d="M99.6796 47.7066C82.3404 56.8882 156.425 74.8269 116.638 79.8685M116.638 79.8685C86.7302 83.6581 53.2573 83.1624 20.3932 73.6971C13.06 70.3066 0.858431 60.2491 10.718 47.1429C20.5775 34.0368 31.2052 43.0927 35.2867 49.259C37.189 52.3637 41.0974 59.2374 41.5123 61.8941C42.031 65.2149 45.6796 12.3416 78.0579 7.28467C83.4975 6.7186 96.1018 8.46373 103.002 19.9729L112.447 31.2547C120.462 69.5071 118.581 79.6024 116.638 79.8685Z"
      stroke="#F08BA9"
    />
    <ellipse cx="81.5405" cy="98.6009" rx="3.57076" ry="7.14153" fill="black" />
    <ellipse cx="127.564" cy="98.6009" rx="3.57076" ry="7.14153" fill="black" />
    <path
      d="M137.776 118.001C137.776 132.775 123.003 144.918 104.552 144.918C86.1014 144.918 71.3282 132.775 71.3282 118.001C71.3282 114.256 72.2644 112.66 73.6704 112.075C74.411 111.767 75.3567 111.701 76.5272 111.843C77.6946 111.986 79.0411 112.33 80.5576 112.801C81.8102 113.189 83.1721 113.662 84.6283 114.168C90.1774 116.097 97.0958 118.501 104.552 118.501C112.008 118.501 118.927 116.097 124.476 114.168C125.932 113.662 127.294 113.189 128.547 112.801C130.063 112.33 131.41 111.986 132.577 111.843C133.748 111.701 134.693 111.767 135.434 112.075C136.84 112.66 137.776 114.256 137.776 118.001Z"
      fill="white"
      stroke="black"
    />
  </svg>
</template>

<script>
export default {
  name: "SalmonIcon"
};
</script>
